var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneNotFound = function SvgPhoneNotFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3664 44.0915L42.7351 41.565C43.7397 40.4934 45.2493 40.0562 46.6634 40.4536C49.5132 41.2544 52.9723 42.2917 55.3887 43.0544C57.1697 43.6166 58.08 45.4075 57.477 47.175C53.768 58.0464 45.5745 59.5643 41.6478 58.8503C17.7312 52.9488 5.28108 32.5783 2.0456 23.1307C-1.88517 8.71784 6.06749 3.05638 12.6136 1.48312C14.5404 1.02004 16.2956 2.44138 16.6639 4.3885L18.3104 13.0912C18.5766 14.4981 18.0716 15.9411 17.02 16.9128C16.2814 17.5952 15.4911 18.3404 14.8031 18.9942C13.6522 20.088 13.2556 21.7719 13.9198 23.2141C18.9288 34.0906 29.112 41.6503 36.0948 44.9879C37.5523 45.6845 39.2616 45.27 40.3664 44.0915Z",
    stroke: "#7B7B7B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3779 13.2511V17.289M37.3779 21.3269H37.388M47.4726 17.289C47.4726 22.8642 42.953 27.3837 37.3779 27.3837C31.8027 27.3837 27.2832 22.8642 27.2832 17.289C27.2832 11.7139 31.8027 7.19434 37.3779 7.19434C42.953 7.19434 47.4726 11.7139 47.4726 17.289Z",
    stroke: "#FF6057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneNotFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneNotFound.b174ac82.svg";
export { ForwardRef as ReactComponent };